import { COPILOT_URL } from '../utils/constants';

export const COPILOT_DISPATCH_URL = COPILOT_URL;

/** Invite Sage into the current Meetgeek room (idempotent — one Sage per room). */
export async function inviteSage({
  roomName,
  recruiter_identity,
  language = 'English',
  resume_score_id,
}) {
  const response = await fetch(`${COPILOT_DISPATCH_URL}/copilot/start`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      roomName,
      recruiter_identity: recruiter_identity || undefined,
      language,
      resume_score_id: resume_score_id || undefined,
    }),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.detail || err.error || 'Failed to invite Sage');
  }
  return response.json();
}

/** Check whether Sage is already running in this room. */
export async function getSageStatus(roomName) {
  const response = await fetch(
    `${COPILOT_DISPATCH_URL}/copilot/status/${encodeURIComponent(roomName)}`
  );
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.detail || err.error || 'Failed to get Sage status');
  }
  return response.json();
}

export async function dismissSage({ roomName, session_id }) {
  const response = await fetch(`${COPILOT_DISPATCH_URL}/copilot/stop`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ roomName, session_id }),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.detail || err.error || 'Failed to dismiss Sage');
  }
  return response.json();
}

/** @deprecated use inviteSage */
export const startCopilot = inviteSage;
/** @deprecated use dismissSage */
export const stopCopilot = dismissSage;
